// dom.ts — shared DOM builders for the status-effect card + modify form. Built with the DOM API
// (createElement + textContent) so all text is escaped intrinsically; the only innerHTML is trusted
// iconMap() output (same discipline as catalog-list/render-card.ts).

import { creatureLabel } from './resolve-refs';

/** Raw trusted iconMap() HTML string (or '' on miss) — for injecting into a button/span innerHTML. */
export function iconHtml(rawId: string): string {
    if (!rawId) return '';
    try { return iconMap(rawId); } catch { return ''; }
}

/** Trusted iconMap() HTML wrapped in a span; '' (no icon) yields an empty span. */
export function iconSpan(rawId: string, cls = ''): HTMLElement {
    const span = document.createElement('span');
    if (cls) span.className = cls;
    if (rawId) span.innerHTML = iconHtml(rawId);
    return span;
}

/** A bordered section wrapper (the PHP card's repeated `border rounded p-3 mb-3`). */
export function section(): HTMLElement {
    const d = document.createElement('div');
    d.className = 'border rounded p-3 mb-3';
    return d;
}

/**
 * A clickable creature/origin reference (icon + name) that opens the side info panel, like the PHP card.
 * The label is resolved from the warm caster cache; falls back to the passed name then 'Unknown'.
 */
export function clickableRef(id: string, fallbackName: string, fallbackType: string): HTMLElement {
    const label = creatureLabel(id);
    const span = document.createElement('span');
    span.className = 'link-primary';
    span.setAttribute('role', 'button');
    const type = label.type || fallbackType;
    if (type) span.appendChild(iconSpan(type, 'me-1'));
    span.appendChild(document.createTextNode(label.name || fallbackName || 'Unknown'));
    span.addEventListener('click', () => {
        if (id && typeof openItemInfo === 'function') openItemInfo(id);
    });
    return span;
}

/** A labelled number input wired to the id modifyCreatureStatusEffect() reads on save. */
export function numberInput(id: string, label: string, value: string): HTMLElement {
    const col = document.createElement('div');
    col.className = 'col-4';
    col.appendChild(document.createTextNode(`${label}: `));
    const input = document.createElement('input');
    input.id = id;
    input.className = 'form-control';
    input.type = 'number';
    input.value = value;
    col.appendChild(input);
    return col;
}
